// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-custom[data-v-2a29087e]{padding:40px;height:100%}@media(min-width: 768px)and (max-width: 991.98px){.card-custom[data-v-2a29087e]{height:calc(100% - 1.5rem);margin-bottom:1.5rem}}.text-blue[data-v-2a29087e]{color:#59b0d3}.text-aqua[data-v-2a29087e]{color:#79c7b9}.bg-warning-50[data-v-2a29087e]{background-color:#fff0e5}.ui-dark .bg-warning-50[data-v-2a29087e]{background-color:#4c2f18}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
